import { Box } from '@palmetto/palmetto-components';
import { format } from 'date-fns';

import EventBy from './EventBy';

const OperationAtCalculated = ({ event }: { event: any }) => {
  const operationAtDate = event?.data?.operationAtDate
    ? format(new Date(event.data.operationAtDate), 'MMM d, yyyy')
    : 'N/A';

  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} />
        <span> Operation At date calculated: </span>
        <strong>{operationAtDate}</strong>
      </Box>
    </Box>
  );
};

export default OperationAtCalculated;
